import { bool, number, shape, string } from 'prop-types'

export const userDataType = shape({
  cartItems: number,
  isLoggedIn: bool,
  user: shape({
    code: string,
    firstname: string,
    lastname: string,
    email: string,
  }),
})
